import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import { FaChevronDown } from 'react-icons/fa';

const placeholders = ['A1', 'B1', 'C1', 'D1', 'A2', 'B2', 'C2', 'D2', 'Winner QF1', 'Winner QF2', 'Winner QF3', 'Winner QF4', 'Loser SF1', 'Loser SF2', 'Winner SF1', 'Winner SF2'];

const styles = require('./GameList-styles.css');

const GameList = ({ className, data }) => {
  const [expandedGame, setExpandedGame] = useState(null);
  const handleExpandGameClick = useCallback((event) => {
    const gameno = Number(event.currentTarget.dataset.gameno);
    setExpandedGame(gameno === expandedGame ? null : gameno);
  });

  return (
    <div className={classnames(styles.list, className)}>
      {data && data[0].qNodes.map((gameday) => (
        <div key={gameday.qElemNo} className={styles.gameday}>
          <div className={styles.gamedayDate}>{gameday.qText}</div>
          {gameday.qNodes.map((game) => (
            <div key={game.qElemNo} className={styles.game}>
              <div className={styles.gameHeader}>
                <div className={styles.gameHeaderDetails}>
                  <div>{game.qAttrDims.qValues[0].qText}</div>
                  <div>{game.qAttrDims.qValues[1].qText}</div>
                  <div>{game.qAttrDims.qValues[2].qText}</div>
                  <div className={classnames(styles.live, (game.qAttrDims.qValues[8].qText === 'In progress' || game.qAttrDims.qValues[8].qText === 'interval') && styles.inProgress, game.qAttrDims.qValues[8].qText === 'Finished' && styles.finished)}>{game.qAttrDims.qValues[8].qText}</div>
                  <div />
                </div>
                <div className={styles.gameHeaderVs}>
                  {!placeholders.includes(game.qAttrDims.qValues[4].qText) && (
                    <div className={styles.vsImg}>
                      <img src={`assets/flags/${game.qAttrDims.qValues[4].qText}.png`} alt={`Flag of ${game.qAttrDims.qValues[4].qText}`} />
                    </div>
                  )}
                  <div className={styles.vsText}>{game.qAttrDims.qValues[3].qText}</div>
                  {!placeholders.includes(game.qAttrDims.qValues[5].qText) && (
                    <div className={styles.vsImg}>
                      <img src={`assets/flags/${game.qAttrDims.qValues[5].qText}.png`} alt={`Flag of ${game.qAttrDims.qValues[5].qText}`} />
                    </div>
                  )}
                </div>
                <div type="button" className={classnames(styles.gameHeaderButton, game.qNodes[0].qElemNo === -2 && styles.disabled)} data-gameno={game.qElemNo} onClick={handleExpandGameClick}>
                  <span>GAME DETAILS</span>
                  <FaChevronDown className={classnames(styles.chevron, expandedGame === game.qElemNo && styles.flip)} />
                </div>
              </div>
              <div
                className={classnames(
                  styles.gameDetails,
                  expandedGame === game.qElemNo && styles.expanded,
                )}
              >
                {[game.qAttrDims.qValues[4], game.qAttrDims.qValues[5]].map((team, teamIndex) => (
                  <div key={team.qText} className={styles.team}>
                    <div className={styles.score}>
                      {teamIndex === 0 && game.qAttrDims.qValues[6].qText}
                      {teamIndex === 1 && game.qAttrDims.qValues[7].qText}
                    </div>
                    <div className={styles.actionContainer} style={{ height: 36 * (game.qNodes.length + 1) }}>
                      {game.qNodes
                        .map((action, actionIndex) => ({ ...action, position: actionIndex + 1 }))
                        .filter((action) => action.qAttrDims.qValues[0].qText === team.qText)
                        .map((action) => (
                          <div key={action.qElemNo} className={styles.action} style={{ top: 36 * (action.position - 1) }}>
                            <div>{action.qAttrDims.qValues[2].qText}</div>
                            <div className={styles.actionStyle}>{action.qAttrDims.qValues[1].qText}</div>
                          </div>
                        ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

GameList.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array,
};
GameList.defaultProps = {
  className: null,
  data: null,
};

export default GameList;
